export default "__VITE_ASSET__Ke4sF0vF__"